import socketIO from 'socket.io-client';

let url = process.env.REACT_APP_HOST || window.location.origin;
console.log('Socket connecting to:', url);

const socket = socketIO(url, { 
  transports: ['websocket'],
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
  timeout: 20000 
});

// Track active subscriptions; allow multiple listeners per channel.
const activeSubscriptions = new Map();

socket.on('connect', () => {
  console.log('Connected to socket server:', socket.id);
});

socket.on('disconnect', () => {
  console.log('Disconnected from socket server');
});

// Enhanced subscribe function
const subscribe = (channel, callback) => {
  // Convert ObjectId to string if needed
  const channelString = channel.toString();
  
  console.log(`Subscribing to channel: ${channelString}`);
  
  if (!activeSubscriptions.has(channelString)) {
    const callbacks = new Set();
    const handler = (data) => {
      console.log(`Received message on ${channelString}:`, data);
      callbacks.forEach((cb) => {
        try {
          cb(data);
        } catch (err) {
          console.error(`Socket subscriber failed on ${channelString}:`, err);
        }
      });
    };

    socket.on(channelString, handler);
    socket.on(`${channelString}-invoiceList`, handler);
    socket.emit('subscribe', channelString);

    activeSubscriptions.set(channelString, { callbacks, handler });
  }

  const entry = activeSubscriptions.get(channelString);
  entry.callbacks.add(callback);
  
  // Return cleanup function
  return () => {
    const current = activeSubscriptions.get(channelString);
    if (!current) return;
    current.callbacks.delete(callback);
    if (current.callbacks.size > 0) return;
    socket.off(channelString, current.handler);
    socket.off(`${channelString}-invoiceList`, current.handler);
    activeSubscriptions.delete(channelString);
  };
};

// Enhanced send function
const send = (channel, message) => {
  if (!socket.connected) {
    console.warn('Socket not connected, attempting to send to:', channel);
    return;
  }
  
  const channelString = channel.toString();
  console.log(`Emitting to ${channelString}:`, message);
  socket.emit(channelString, message);
};

// Debug logging in development
if (process.env.NODE_ENV === 'development') {
  // socket.onAny((event, ...args) => {
  //   console.log(`Socket Event [${event}]:`, args);
  // });
}

export {
  socket,
  subscribe,
  send
};
